import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { division } from './../../models/admin';
import { UtilityService } from './../../services/utility.service';
import { SLAKPIApiService } from './../../services/slakpi.service';
import { AdminApiService } from './../../services/admin.service';
import { UserService } from './../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { sla, kpiRelease, quater, year, kpi, kpiInbox, kpiViewDashBoard } from './../../models/slakpi';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { GaugeChartModule } from 'angular-gauge-chart'
var filterParams = {
  comparator: function (filterLocalDateAtMidnight, cellValue) {
    var dateAsString = cellValue;
    if (dateAsString == null) return -1;
    var dateParts = dateAsString.split('/');
    var cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0])
    );
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
  },
  browserDatePicker: true,
};

@Component({
  selector: 'app-sladashboard',
  templateUrl: './sladashboard.component.html',
  styleUrls: ['./sladashboard.component.css']
})
export class SLADashboardComponent implements OnInit {

  chartOptionslakpiperformancechart: any = {};
  chartOptionslakpiperformancereport: any = {};
  public gridApi;
  public gridColumnApi;

  public columnDefs;
  public defaultColDef;
  public rowData: [];
  showMyContainer: boolean = false;
  divisionPlaceholder: string = 'Select Division';
  
  public title: string = '';
  public yearData: any;
  public quaterData: any;
  public division_data: any;

  public kpiDashboard_data: any;
  public slakpiDashboard_data: any;
  public kpiDashboard_data_chart: any = [];
  public kpiDashboard_data_chart_report: any = [];
  public slakpiDashboard_data_chart: object[] = [];
  public yearUno?: number = 0;
  public quarterUno?: number = 0;
  public divisionUno?: number = 0;
  public annotaions: object;
  public isKPIReported: boolean = false;
  public isAdmin: boolean = false;
  public userRole: string = '';
  public loading: boolean = true;
  //@ViewChild('circulargauge', { static: false }) circulargauge: CircularGaugeComponent;

  //************************* Kpi Dashboard
  //Initializing Legend
  public legendSettings_kpi: Object = {
    visible: true,
    toggleVisibility: true

  };
  public dataLabel_kpi: Object = {
    visible: true, position: 'Outside',
    connectorStyle: { type: 'Line', length: '5%' },
    name: 'reportUnderperformingCountString'
  };
  public explode_kpi: boolean = true;
  public clubvalue: string = '9';
  public startAngle_kpi: number = 0;
  public endAngle_kpi: number = 360;
  //Initializing Tooltip

  public kpiDashboardtitle: string = 'Under-Performing KPIs Breakdown';
  //************************* Kpi Dashboard End
   

  //Initializing Legend
  public legendSettings: Object = {
    visible: true,
    toggleVisibility: true

  };
  //Initializing Datalabel
  public dataLabel: Object = {
    visible: true, position: 'Outside',
    border: { width: 2, color: '#90ee90' },
    name: 'r'
  };
  public dataLabel_sla: Object = { visible: true, name: 'text', position: 'Outside' };

  //for Users Default Value
  user: any = {};
  login_UserID: string = ''; // number
  currentYear?: number = 0;
  currentHalf?: number = 0;
  currentQuarter?: number = 0;
  currentMonth?: number = 0;

  //for KPI
  public wellperformKPIRange?: number = 0;
  public wellPerformedTargetKPICount?: number = 0;
  public underPerformedTargetKPICount?: number = 0;
  public naTargetKPICount?: number = 0;
  public totalKPIAverage?: number = 0;
  public totalKPIReported?: number = 0;
  public year_slakpi?: number = 0;
  public quater_slakpi?: number = 0;
  public division_slakpi?: number = 0;
  //For SLAKPI
  public wellperformSLAKPIRange?: number = 0;
  public wellPerformedTargetSLAKPICount?: number = 0;
  public underPerformedTargetSLAKPICount?: number = 0;
  public naTargetSLAKPICount?: number = 0;
  public totalSLAKPIAverage?: number = 0;
  public totalSLAKPIReported?: number = 0;
  public year_sla?: number = 0;
  public quater_sla?: number = 0;

  //For Report
  public noOfSLAKPICount?: number = 0;
  public noOfSLAKPICountTotal?: number = 0;
  public noOfMonthlyCount?: number = 0;
  public noOfYearlyCount?: number = 0;
  public noOfQuarterlyCount?: number = 0;
  public noOfSemiYearlyKPICount?: number = 0;
  public noOfReleasedKPICount?: number = 0;
  public noOfKPICompletedDataEntryStageCount?: number = 0;
  public noOfKPIReportedAsNACount?: number = 0;
  public noOfKPIReportedAsNACount_NA?: number = 0;
  public noOfKPIReportedAsNACount_NR?: number = 0;
  public noOfKPIReportedAsNACount_ND?: number = 0;
  public noOfKPICompletedByStage1Count?: number = 0;
  public noOfKPICompletedByStage2Count?: number = 0;
  public noOfKPICompletedByStage3Count?: number = 0;

  public noOfKPIProgressDataEntryStageCount?: number = 0;
  public noOfKPIProgressByStage1Count?: number = 0;
  public noOfKPIProgressByStage2Count?: number = 0;
  public noOfKPIProgressByStage3Count?: number = 0;


  public wellPerformedSLAKPICount?: number = 0;
  public underPerformedSLAKPICount?: number = 0;
  public reportUnderperformingCount?: number = 0;
  public reportPrecentageCount?: number = 0;
  public reportWellFormedPrecentage?: number = 95;
  public year_reportkpi?: number = 0;
  public quater_reportkpi?: number = 0;
  public division_reportkpi?: number = 0;
  public division_sla?: number = 0;
  isStart: boolean = true;
  public titleDashboard = 'SLA&KPI Dashboard';
  //Guage chart starts
  public canvasWidth = 400
  public needleValue = 0
  public centralLabel = ''
  
  public name = '% of Completion'
  public bottomLabel = ''
  public options = {  }
    tenantUno: any;
  slaName: string = '';
  //Guage chart ends
  constructor(public restApi: SLAKPIApiService, public http: HttpClient, private _activatedRoute: ActivatedRoute, public adminService: AdminApiService, public utilityService: UtilityService, private spinner: SpinnerVisibilityService, private router: Router, private userService: UserService) {
    this.columnDefs = [
      { field: 'athlete' },
      {
        field: 'age',
        filter: 'agNumberColumnFilter',
        maxWidth: 100,
      },
      { field: 'country' },
      {
        field: 'year',
        maxWidth: 100,
      },
      {
        field: 'date',
        filter: 'agDateColumnFilter',
        filterParams: filterParams,
      },
      { field: 'sport' },
      {
        field: 'gold',
        filter: 'agNumberColumnFilter',
      },
      {
        field: 'silver',
        filter: 'agNumberColumnFilter',
      },
      {
        field: 'bronze',
        filter: 'agNumberColumnFilter',
      },
      {
        field: 'total',
        filter: false,
      },
    ];
    this.defaultColDef = {
      flex: 1,
      minWidth: 150,
      filter: true,
    };
  }

  /*onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    this.http
      .get(
        'https://raw.githubusercontent.com/ag-grid/ag-grid/master/grid-packages/ag-grid-docs/src/olympicWinners.json'
      )
      .subscribe((data: []) => {
        this.rowData = data;
      });
  }*/

  ngOnInit() {
    this.loading = true;
    this.userService.CheckLogin();
    google.charts.load('current', { 'packages': ['gauge'] });
    google.charts.load('current', { 'packages': ['corechart'] });
    //Load Default Values
    this._activatedRoute.params.subscribe((params: Params) => {

      if (params['pagetype'] != null && params['pagetype'] == 'report') {
        this.titleDashboard = 'Tracking Dashboard';
        this.isKPIReported = true;


      } else {
        this.titleDashboard = 'SLA&KPI Dashboard';
        this.isKPIReported = false;

      }



      this.loadDropdownQYValue();

    });
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.userRole = this.user.role;
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.userRole == 'Administrator' || this.userRole == 'SLA Admin' || this.userRole == 'DDAdmin') ? true : false;
    if (this.tenantUno > 1) { this.divisionPlaceholder="Select"}
    this.slaName = this.user.slaname;
    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.wellperformKPIRange = this.user.wellperformKPIRange;

    this.loadYear();
    this.resetKPICount();
    this.resetSLACount();
    if (this.isKPIReported && this.userRole != 'SLA Coordinator' && !this.isAdmin) {
      this.router.navigateByUrl('/access-denied');
    }
    if (this.isKPIReported && !this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Tracking Dashboard");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }



    this.loadDropdownQYValue();


    this.annotaions = [{

      content: '<div><span style="font-size:14px; color:#9E9E9E; font-family:Regular">Speedometer</span></div>',

      radius: '30%', angle: 0, zIndex: '999'

    }, {

      content: '<div><span style="font-size:24px; color:#424242; font-family:Regular">65 MPH</span></div>',

      radius: '40%', angle: 180, zIndex: '999'

    }];

  }

  findGetParameter(parameterName) {
    var result = null,
      tmp = [];
    if (location.href.split('?').length == 2)
      location.href.split('?')[1]
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
  }


  // Get Year / Quater
  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getYearMaster(inpValue)
      .subscribe(data => {

        this.yearData = data;
        //this.inpyeardata.addItem({ text: 'All', value: '0' }, 0);
        this.loadQuater();
        this.loadDivisions();


      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  loadQuater() {

    let inpValue = new quater();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;

    this.restApi.getQuaterMaster(inpValue)
      .subscribe(data => {

        this.quaterData = data;
        //this.inpquaterdata.addItem({ text: 'All', value: '0' }, 0);
        setTimeout(() => {
          this.loadDropdownQYValue();
        }, 10);
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  loadDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 3;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {

        this.division_data = data;

      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  loadDropdownQYValue() {
    this.loading = true;
    if (this.currentYear) {
      if (this.findGetParameter('quatersla') != null) {
        if (this.isKPIReported) {
          this.year_reportkpi = (this.findGetParameter('yearsla') != null && this.findGetParameter('yearsla') != '') ? Number(this.findGetParameter('yearsla')) : 0;
          this.quater_reportkpi = (this.findGetParameter('quatersla') != null && this.findGetParameter('quatersla') != '') ? Number(this.findGetParameter('quatersla')) : 0;
          this.division_reportkpi = (this.findGetParameter('divisionsla') != null && this.findGetParameter('divisionsla') != '') ? Number(this.findGetParameter('divisionsla')) : 0;
          this.division_slakpi = 0;
          this.year_slakpi = Number(this.currentYear.toString());
          this.quater_slakpi = Number(this.currentQuarter.toString());
          this.year_sla = Number(this.currentYear.toString());
          this.quater_sla = Number(this.currentQuarter.toString());
          this.loadKPIDashBoard(this.year_reportkpi, this.quater_reportkpi, 0, 'report', true);
          this.loadSLAKPIDashBoard(this.year_sla, this.quater_sla, 0, true);
        }
        else {
          if (this.findGetParameter('divisionsla') != null) {
            this.year_slakpi = (this.findGetParameter('yearsla') != null && this.findGetParameter('yearsla') != '') ? Number(this.findGetParameter('yearsla')) : 0;
            this.quater_slakpi = (this.findGetParameter('quatersla') != null && this.findGetParameter('quatersla') != '') ? Number(this.findGetParameter('quatersla')) : 0;
            this.division_slakpi = (this.findGetParameter('divisionsla') != null && this.findGetParameter('divisionsla') != '') ? Number(this.findGetParameter('divisionsla')) : 0;
            this.year_reportkpi = Number(this.currentYear.toString());
            this.quater_reportkpi = Number(this.currentQuarter.toString());
            this.year_sla = Number(this.currentYear.toString());
            this.quater_sla = Number(this.currentQuarter.toString());
            this.loadKPIDashBoard(this.year_slakpi, this.quater_slakpi, this.division_slakpi, 'slakpi', false);
            this.loadSLAKPIDashBoard(this.year_sla, this.quater_sla, this.division_sla, false);
          }
          else {
            this.year_sla = (this.findGetParameter('yearsla') != null && this.findGetParameter('yearsla') != '') ? Number(this.findGetParameter('yearsla')) : 0;
            this.quater_sla = (this.findGetParameter('quatersla') != null && this.findGetParameter('quatersla') != '') ? Number(this.findGetParameter('quatersla')) : 0;
            this.year_reportkpi = Number(this.currentYear.toString());
            this.quater_reportkpi = Number(this.currentQuarter.toString());
            this.year_slakpi = Number(this.currentYear.toString());
            this.quater_slakpi = Number(this.currentQuarter.toString());
            this.division_slakpi = 0;
            this.loadKPIDashBoard(this.year_slakpi, this.quater_slakpi, this.division_slakpi, 'slakpi', false);
            this.loadSLAKPIDashBoard(this.year_sla, this.quater_sla, this.division_sla, false);
          }
        }



      }
      else {
        this.division_slakpi = 0;
        this.division_reportkpi = 0;
        this.year_slakpi = Number(this.currentYear.toString());
        this.quater_slakpi = Number(this.currentQuarter.toString());
        this.year_sla = Number(this.currentYear.toString());
        this.quater_sla = Number(this.currentQuarter.toString());
        this.year_reportkpi = Number(this.currentYear.toString());
        this.quater_reportkpi = Number(this.currentQuarter.toString());
        if (this.isKPIReported) {
          this.loadKPIDashBoard(this.year_reportkpi, this.quater_reportkpi, 0, 'report', true);
          this.loadSLAKPIDashBoard(this.year_sla, this.quater_sla, 0, true);

        } else {
          this.loadKPIDashBoard(this.year_slakpi, this.quater_slakpi, 0, 'slakpi', true);
        }
      }

    }
  }
  loadKPIDashBoard(year: number, quater: number, division: number, type: string, isPageLoad: boolean) {
    this.loading = true;
    if (this.currentQuarter) {
      this.resetKPICount();
      this.spinner.show();
      let inpValue = new kpiViewDashBoard();
      inpValue.userUno = this.login_UserID;

      inpValue.languageUno = 1033;
      inpValue.condition = 1;
      inpValue.tenantUno = this.tenantUno;
      inpValue.currentYear = (year == 0 || year == undefined) ? 0 : year;
      inpValue.currentHalf = this.currentHalf;
      inpValue.currentMonth = this.currentMonth;
      inpValue.currentQuarter = (quater == 0 || quater == undefined) ? 0 : quater;
      inpValue.reportingDivisionUno = (division == 0 || division == undefined) ? 0 : division;
      inpValue.wellperformKPIRange = this.wellperformKPIRange;
      inpValue.dashboardType = type;
      if (!isPageLoad) { this.spinner.show(); }
      this.restApi.getKPIDashboard(inpValue)
        .subscribe(data => {
          
          this.isStart = false;
         
          this.kpiDashboard_data = data[0];
          
          if (type == 'slakpi') {
            this.kpiDashboard_data = data[0];
            if (division == 0) {
              this.kpiDashboard_data_chart = data[0].list_KPIViewDashBoardList;
              let chartData;
              //let tempArray = [['Trends', 'KPI Performance Summary']];
              //for (var i = 0; i < this.kpiDashboard_data_chart.length; i++) {
              //  tempArray.push([this.kpiDashboard_data_chart[i].reportingDivisionName, this.kpiDashboard_data_chart[i].reportUnderperformingCount]);
              //}
              let temp = this;
              //chartData = google.visualization.arrayToDataTable(tempArray);
              var that = this;

              let tempArray = [];
              for (var i = 0; i < this.kpiDashboard_data_chart.length; i++) {
                if (this.kpiDashboard_data_chart[i].reportingDivisionName !="")
                tempArray.push({ name: this.sentenceCase(this.kpiDashboard_data_chart[i].reportingDivisionName), value: this.kpiDashboard_data_chart[i].reportUnderperformingCount });
              }
              
              this.spinner.show();
              setTimeout(() => {
               
                const options = {
                  //slices: {
                  //  0: { color: '#428893' },
                  //  1: { color: '#68b097' },
                  //  2: { color: '#83ceb1' },
                  //  3: { color: '#aaebac' },
                  //  4: { color: '#de8060' },
                  //  5: { color: '#f5d17a' },
                  //  6: { color: '#efa96c' },
                  //  7: { color: '#de8060' },
                  //  8: { color: '#a44b2d' }
                  //},

                  // legend: { position: 'left' },
                  chartArea: { left: 10, top: 50, right: 0, bottom: 10, width: "100%", height: "100%" },
                  pieHole: 0.4,
                  fontSize: 15,
                  legend: {
                    textStyle: {
                      fontSize: 12
                    }
                  }
                };

                //echarts starts
                this.chartOptionslakpiperformancechart = {
                  tooltip: {
                    trigger: "item",
                    formatter: "{c}",
                    textStyle: {
                      fontWeight: "bold",
                      fontSize: 13,

                    }
                  },

                  legend: {
                    bottom: '0',
                    left: 'center',
                    type: 'scroll',
                    orient: 'horizontal',
                    //right: -30,
                    //top: 0,
                    //bottom: 20,
                    pageIconColor: '#087b36',
                    pageIconInactiveColor: '#999999'
                    
                    //orient: "vertical",

                    //padding: [
                    //  20,  // up
                    //  20, // right
                    //  0,  // down
                    //  0, // left
                    //],
                  },
                  color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
                  series: [
                    {
                      name: '',
                      type: 'pie',
                      radius: ['30%', '80%'],
                      center: ["50%", "45%"],
                      avoidLabelOverlap: false,
                      label: {
                        show: true,
                        position: 'inside',
                        color: '#fff',
                        fontSize: '12',
                        formatter: function (d) {
                          return d.value +"%";
                        }
                      },
                      emphasis: {
                        label: {
                          show: true,
                          fontSize: '10',
                          fontWeight: 'bold'
                        }
                      },
                      labelLine: {
                        show: false
                      },
                      data: tempArray
                      //data: [
                      //  { value: 60, name: 'Plan' },
                      //  { value: 20, name: 'Collect' },
                      //  { value: 10, name: 'Adapt' },
                      //  { value: 10, name: 'Analyze' },

                      //]
                    }
                  ]
                };
   // echarts ends
                if (document.getElementById('slakpi_performance_chart')) {
                  const chart = new google.visualization.PieChart(document.getElementById('slakpi_performance_chart'));
                  chart.draw(chartData, options);
                  google.visualization.events.addListener(chart, 'click', () => {
                    if (chart.getSelection().length > 0) {
                      let selRow = chart.getSelection();
                      let text = chartData.cache[selRow[0].row][0]
                      
                      const result = temp.division_data.filter(s => s.divisionNameEn == text['Ve']);
                      if (result.length > 0) {
                        let objdivision_slakpi = result[0].divisionUno;
                        this.router.navigate(['/slakpiperformance'], { queryParams: { yearsla: this.year_slakpi, quatersla: this.quater_slakpi, divisionsla: objdivision_slakpi, performance: 2 } });
                      }
                    }
                  });
                  if (!isPageLoad) { that.spinner.hide(); }
                }
              }, 500);



            }


            let welRangeKPICount = this.kpiDashboard_data.wellPerformedRangeorVarianceKPICount;
            let welTargetKPICount = this.kpiDashboard_data.wellPerformedTargetKPICount;
            let welTextKPICount = this.kpiDashboard_data.wellPerformedTextKPICount;
            let underRangeKPICount = this.kpiDashboard_data.underPerformedRangeorVarianceKPICount;
            let underTargetKPICount = this.kpiDashboard_data.underPerformedTargetKPICount;
            let underTextKPICount = this.kpiDashboard_data.underPerformedTextKPICount;
            let naRangeKPICount = this.kpiDashboard_data.naRangeorVarianceKPICount;
            let naTargetKPICount = this.kpiDashboard_data.naTargetKPICount;
            let naTextKPICount = this.kpiDashboard_data.naTextKPICount;


            this.wellPerformedTargetKPICount = welRangeKPICount + welTargetKPICount + welTextKPICount
            this.underPerformedTargetKPICount = underRangeKPICount + underTargetKPICount + underTextKPICount;
            this.naTargetKPICount = this.kpiDashboard_data.naRangeorVarianceKPICount;
            

            this.totalKPIReported = welRangeKPICount + welTargetKPICount + welTextKPICount + underRangeKPICount + underTargetKPICount + underTextKPICount + naRangeKPICount + naTargetKPICount + naTextKPICount;
            //this.kpiDashboard_data.wellPerformedRangeorVarianceKPICount + this.kpiDashboard_data.naRangeorVarianceKPICount + this.kpiDashboard_data.underPerformedRangeorVarianceKPICount + welTargetKPICount + welTextKPICount + underTargetKPICount + underTextKPICount;
            this.totalKPIAverage = ((this.wellPerformedTargetKPICount / (this.wellPerformedTargetKPICount + this.underPerformedTargetKPICount)) * 100);
            this.totalKPIAverage = this.RoundNum((isNaN(this.totalKPIAverage) || this.totalKPIAverage == NaN || this.totalKPIAverage <= 0) ? 0 : parseFloat(this.totalKPIAverage.toFixed()), 0);
            this.loading = false;
          }
          if (type == 'report') {


            if (division == 0 || division==null) {
              this.kpiDashboard_data_chart_report = data[0].list_KPIViewDashBoardList;
              let chartData;
              // let tempArray = [['Trends', 'KPI Performance Summary']];
              //for (var i = 0; i < this.kpiDashboard_data_chart_report.length; i++) {
              //  tempArray.push([this.kpiDashboard_data_chart_report[i].reportingDivisionName, this.kpiDashboard_data_chart_report[i].reportUnderperformingCount]);
              //}

             
              let temp = this;
             // chartData = google.visualization.arrayToDataTable(tempArray);

              let tempArray = [];
              for (var i = 0; i < this.kpiDashboard_data_chart_report.length; i++) {
                if (this.kpiDashboard_data_chart_report[i].reportingDivisionName != "")
                tempArray.push({ name: this.sentenceCase(this.kpiDashboard_data_chart_report[i].reportingDivisionName), value: this.kpiDashboard_data_chart_report[i].reportUnderperformingCount });
              }
              setTimeout(() => {
                if (!isPageLoad) { temp.spinner.hide(); }
                const options = {
                  
                  //slices: {
                  //  0: { color: '#428893' },
                  //  1: { color: '#68b097' },
                  //  2: { color: '#83ceb1' },
                  //  3: { color: '#aaebac' },
                  //  4: { color: '#de8060' },
                  //  5: { color: '#f5d17a' },
                  //  6: { color: '#efa96c' },
                  //  7: { color: '#de8060' },
                  //  8: { color: '#a44b2d' }
                  //},
                 
                 // legend: { position: 'left' },
                  chartArea: { left: 10, top: 50, right: 0, bottom: 10, width: "100%", height: "100%" },
                  pieHole: 0.4,
                  fontSize: 15,
                  legend: {
                    textStyle: {
                      fontSize: 12
                    }
                  }
                };

                //echarts starts
                this.chartOptionslakpiperformancereport = {
                  tooltip: {
                    trigger: "item",
                    formatter: "{c}",
                    textStyle: {
                      fontWeight: "bold",
                      fontSize: 13
                    }
                  },
                 
                  legend: {
                    bottom: '0',
                    left: 'center',
                    type: 'scroll',
                    orient: 'horizontal',
                    //right: -30,
                    //top: 0,
                    //bottom: 20,
                    pageIconColor: '#087b36',
                    pageIconInactiveColor: '#999999'
                  },
                  color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
                  series: [
                    {
                      name: '',
                      type: 'pie',
                      radius: ['30%', '80%'],
                      center: ["50%", "45%"],
                      avoidLabelOverlap: true,
                      label: {
                        show: true,
                        position: 'inside',
                        color: '#fff',
                        fontSize: '12',
                        formatter: function (d) {
                          return  d.value + "%";
                        }
                      },
                      emphasis: {
                        label: {
                          show: true,
                          fontSize: '10',
                          fontWeight: 'bold'
                        }
                      },
                      labelLine: {
                        show: true
                      },

                      data: tempArray
                    }
                  ]
                };
   // echarts ends

                if (document.getElementById('slakpi_performance_report')) {
                  const chart = new google.visualization.PieChart(document.getElementById('slakpi_performance_report'));
                  chart.draw(chartData, options);
                  // orgChart is my global orgchart chart variable.
                  google.visualization.events.addListener(chart, 'select', () => {
                    if (chart.getSelection().length > 0) {
                      let selRow = chart.getSelection();
                      let text = chartData.cache[selRow[0].row][0]
                      
                      const result = temp.division_data.filter(s => s.divisionNameEn == text['Ve']);
                      if (result.length > 0) {
                        let objdivision_slakpi = result[0].divisionUno;
                        this.router.navigate(['/slakpiperformance'], { queryParams: { yearsla: this.year_reportkpi, quatersla: this.quater_reportkpi, divisionsla: objdivision_slakpi, performance: 2 } });
                      }
                    }
                  });
                }
                this.loading = false;
              }, 500);
            }
            this.noOfSLAKPICount = this.kpiDashboard_data.noOfSLAKPICount;
            this.noOfMonthlyCount = this.kpiDashboard_data.noOfMonthlyKPICount;
            this.noOfYearlyCount = this.kpiDashboard_data.noOfYearlyKPICount;
            // this.noOfQuarterlyCount = this.kpiDashboard_data.noOfQuarterlyKPICount;
            // this.noOfSemiYearlyKPICount = this.kpiDashboard_data.noOfSemiYearlyKPICount;

            this.noOfSLAKPICountTotal = this.noOfSLAKPICount + this.noOfMonthlyCount + this.noOfYearlyCount;


            this.noOfReleasedKPICount = this.kpiDashboard_data.noOfReleasedKPICount;

            this.noOfKPICompletedDataEntryStageCount = this.kpiDashboard_data.noOfKPICompletedDataEntryStageCount;
            this.noOfKPIProgressDataEntryStageCount = this.kpiDashboard_data.noOfKPIProgressDataEntryStageCount;

            this.noOfKPICompletedByStage1Count = this.kpiDashboard_data.noOfKPICompletedByStage1Count;
            this.noOfKPICompletedByStage2Count = this.kpiDashboard_data.noOfKPICompletedByStage2Count;
            this.noOfKPICompletedByStage3Count = this.kpiDashboard_data.noOfKPICompletedByStage3Count;

            this.noOfKPIProgressByStage1Count = this.kpiDashboard_data.noOfKPIProgressByStage1Count;
            this.noOfKPIProgressByStage2Count = this.kpiDashboard_data.noOfKPIProgressByStage2Count;
            this.noOfKPIProgressByStage3Count = this.kpiDashboard_data.noOfKPIProgressByStage3Count;

            
            //Latest changes May11-- client wants to change the condition based on the Year
            if (year < 2019 || (year == 2019 && quater <= 2)) {
              this.noOfKPIReportedAsNACount_NA = this.kpiDashboard_data.noOfKPIReportedAsNACount_NA;
              this.noOfKPIReportedAsNACount_NR = this.kpiDashboard_data.noOfKPIReportedAsNACount_NR;
              this.noOfKPIReportedAsNACount_ND = this.kpiDashboard_data.noOfKPIReportedAsNACount_ND;
              //this.noOfKPIReportedAsNACount = this.kpiDashboard_data.noOfKPIReportedAsNACount;

            } else {

              this.noOfKPIReportedAsNACount_NA = this.kpiDashboard_data.noOfKPIReportedAsNACount_NA + this.kpiDashboard_data.noOfKPIReportedAsNACount_NR + this.kpiDashboard_data.noOfKPIReportedAsNACount_ND;
              this.noOfKPIReportedAsNACount_NR = (this.noOfReleasedKPICount - this.noOfKPICompletedByStage3Count);//this.kpiDashboard_data.noOfKPIReportedAsNACount_NR;
              this.noOfKPIReportedAsNACount_ND = (this.noOfSLAKPICountTotal - this.noOfReleasedKPICount);//this.kpiDashboard_data.noOfKPIReportedAsNACount_ND;
              //this.noOfKPIReportedAsNACount = this.kpiDashboard_data.noOfKPIReportedAsNACount;

            }
            this.noOfKPIReportedAsNACount_NA = (this.noOfKPIReportedAsNACount_NA <= 0) ? 0 : this.noOfKPIReportedAsNACount_NA;
            this.noOfKPIReportedAsNACount_NR = (this.noOfKPIReportedAsNACount_NR <= 0) ? 0 : this.noOfKPIReportedAsNACount_NR;
            this.noOfKPIReportedAsNACount_ND = (this.noOfKPIReportedAsNACount_ND <= 0) ? 0 : this.noOfKPIReportedAsNACount_ND;

            this.noOfKPIReportedAsNACount = this.noOfKPIReportedAsNACount_NA + this.noOfKPIReportedAsNACount_NR + this.noOfKPIReportedAsNACount_ND;



            //this.noOfKPIPedByStage3Count = this.kpiDashboard_data.noOfKPICompletedByStage3Count;
            // this.wellPerformedSLAKPICount = this.kpiDashboard_data.wellPerformedSLAKPICount;
            // this.underPerformedSLAKPICount = this.kpiDashboard_data.underPerformedSLAKPICount;
            //  this.reportUnderperformingCount = this.kpiDashboard_data.reportUnderperformingCount;

            this.reportPrecentageCount = parseFloat((((this.noOfKPICompletedByStage3Count) / this.noOfReleasedKPICount) * 100).toFixed(2));
            this.reportPrecentageCount = (!isNaN(this.reportPrecentageCount)) ? this.reportPrecentageCount : 0;
            //this.reportPrecentageCount = 70;
            this.loadReportPrecentageValue_Color(this.reportPrecentageCount);
            this.needleValue = this.reportPrecentageCount;
            this.name = this.reportPrecentageCount.toString() + '% of Completion'

            this.options = {
              hasNeedle: true,
              needleColor: 'gray',
              needleUpdateSpeed: 1000,
              arcColors: ['rgb(104, 176, 128)', 'rgb(172, 172, 172)'],
              arcDelimiters: [this.needleValue],
              rangeLabel: ['0', '100'],
              needleStartValue: 50,
            }
          }
          this.loading = false;
        },
          (error) => {
            //Called when error
            this.loading = false;
            if (!isPageLoad) { this.spinner.hide(); }
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //if (!isPageLoad) { this.spinner.hide(); }
        });
    }
  }
  loadReportPrecentageValue_Color(sliderValue: number) {
    //sliderValue = (sliderValue == 0) ? 90 : sliderValue;
    if (!isNaN(sliderValue) && sliderValue > 0) {

      sliderValue = sliderValue > 100 ? 100 : sliderValue;
      this.reportPrecentageCount = sliderValue;
      //  this.circulargauge['isProtectedOnChange'] = true;
      //  if (sliderValue >= 0 && sliderValue < 20) {
      //    this.circulargauge.axes[0].pointers[0].color = '#ea501a';
      //    // this.circulargauge.setPointerValue(0, 0, 10);
      //  } else if (sliderValue >= 20 && sliderValue < 40) {
      //    this.circulargauge.axes[0].pointers[0].color = '#f79c02';
      //    //this.circulargauge.setPointerValue(0, 0, 30);
      //  } else if (sliderValue >= 40 && sliderValue < 60) {
      //    this.circulargauge.axes[0].pointers[0].color = '#e5ce20';
      //    // this.circulargauge.setPointerValue(0, 0, 50);
      //  } else if (sliderValue >= 60 && sliderValue < 80) {
      //    this.circulargauge.axes[0].pointers[0].color = '#a1cb43';
      //    //this.circulargauge.setPointerValue(0, 0, 70);
      //  } else if (sliderValue >= 80 && sliderValue < 100) {
      //    this.circulargauge.axes[0].pointers[0].color = '#82b944';
      //    //this.circulargauge.setPointerValue(0, 0, 100);
      //  }
      //  this.circulargauge.setPointerValue(0, 0, Number(sliderValue.toFixed()));
      //  if (document.getElementById('range-container_Secondary_Element')) {
      //    document.getElementById('range-container_Secondary_Element').innerHTML = '<div id="pointervalue">' + this.circulargauge.axes[0].pointers[0].value.toString() + '/100</div>';
      //  }

      //this.circulargauge.destroy();
      ////this.circulargauge['isProtectedOnChange'] = true;

      ////this.circulargauge.setPointerValue(0, 0, sliderValue);
      ////this.circulargauge.setPointerValue(0, 1, sliderValue);
      //if (document.getElementById('progress_chart_div')) {
      //  var data = google.visualization.arrayToDataTable([
      //    ['Label', 'Value'],
      //    ['', sliderValue]
      //  ]);

      //  setTimeout(() => {
      //    var options = {
      //      greenFrom: 91, greenTo: 100,
      //      redFrom: 0, redTo: 30,
      //      yellowFrom: 31, yellowTo: 90,
      //      minorTicks: 5
      //    };
      //    var chart = new google.visualization.Gauge(document.getElementById('progress_chart_div'));
      //    chart.draw(data, options);
      //  }, 3000);
      //}
      
      //this.circulargauge.setAnnotationValue(0, 0, '<div style="color:#666666;font-size:35px;">' + sliderValue + '' + '</div>');

      ////this.circulargauge.refresh();
    }
    else {
      //
      //this.circulargauge.setPointerValue(0, 0, 0);
      //this.circulargauge.setPointerValue(0, 1, 0);
      ////this.circulargauge.setAnnotationValue(0, 0, '<div style="color:#666666;font-size:35px;"></div>');
      //this.circulargauge.refresh();
      //this.circulargauge.axes[0].pointers[0].value = 0;

    }
  }

  loadSLAKPIDashBoard(year: number, quater: number, division_sla: number, isPageLoad: boolean) {
    this.loading = true;
    this.resetSLACount();
    let inpValue = new kpiViewDashBoard();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.currentYear = year;
    inpValue.currentHalf = this.currentHalf;
    inpValue.currentMonth = this.currentMonth;
    inpValue.currentQuarter = quater;
    inpValue.reportingDivisionUno = division_sla;
    inpValue.wellperformKPIRange = this.wellperformKPIRange;
    if (!isPageLoad) { this.spinner.show(); }
    this.restApi.getSLAKPIDashboard(inpValue)
      .subscribe(data => {
        
        this.isStart = false;
        this.slakpiDashboard_data_chart = null;
        if (!isPageLoad) { this.spinner.hide(); }
        this.slakpiDashboard_data = data[0];

        this.wellPerformedTargetSLAKPICount = this.slakpiDashboard_data.wellPerformedRangeorVarianceSLACount;
        this.underPerformedTargetSLAKPICount = this.slakpiDashboard_data.underPerformedRangeorVarianceSLACount;
        this.naTargetSLAKPICount = this.slakpiDashboard_data.naRangeorVarianceSLACount;
        this.totalSLAKPIReported = this.slakpiDashboard_data.wellPerformedRangeorVarianceSLACount + this.slakpiDashboard_data.naRangeorVarianceSLACount + this.underPerformedTargetSLAKPICount;
        this.totalSLAKPIAverage = (this.wellPerformedTargetSLAKPICount / (this.wellPerformedTargetSLAKPICount + this.underPerformedTargetSLAKPICount)) * 100;
        this.totalSLAKPIAverage = this.RoundNum((isNaN(this.totalSLAKPIAverage) || this.totalSLAKPIAverage == NaN || this.totalSLAKPIAverage <= 0) ? 0 : parseFloat(this.totalSLAKPIAverage.toFixed()), 0);

        this.reportWellFormedPrecentage = parseFloat((((this.wellPerformedTargetSLAKPICount) / this.totalSLAKPIReported) * 100).toFixed());
        this.reportWellFormedPrecentage = (!isNaN(this.reportWellFormedPrecentage)) ? this.reportWellFormedPrecentage : 0;

        //calculate Well/ under precentage
        let wellprecentage: number = this.RoundNum((((this.wellPerformedTargetSLAKPICount) / (this.wellPerformedTargetSLAKPICount + this.underPerformedTargetSLAKPICount)) * 100), 0);//.toFixed();
        let underprecentage: number = this.RoundNum((((this.underPerformedTargetSLAKPICount) / (this.wellPerformedTargetSLAKPICount + this.underPerformedTargetSLAKPICount)) * 100), 0);//.toFixed();
        let sladashboardXval_well: string = 'Well-Performing [#' + this.wellPerformedTargetSLAKPICount + ']';
        let sladashboardRvalper_well: string = this.wellPerformedTargetSLAKPICount.toString() + " (" + wellprecentage + "%)";
        let sladashboardXval_under: string = 'Under-Performing [#' + this.underPerformedTargetSLAKPICount + ']';
        let sladashboardRvalper_under: string = this.underPerformedTargetSLAKPICount.toString() + " (" + underprecentage + "%)";
        let chartData;
        if (this.wellPerformedTargetSLAKPICount > 0 && this.underPerformedTargetSLAKPICount > 0) {
          chartData = google.visualization.arrayToDataTable([
            ['Trends', 'KPI Performance Summary'],
            [sladashboardXval_under, this.underPerformedTargetSLAKPICount],
            [sladashboardXval_well, this.wellPerformedTargetSLAKPICount]
          ]);
        }

        if (this.wellPerformedTargetSLAKPICount > 0 && this.underPerformedTargetSLAKPICount <= 0) {
          chartData = google.visualization.arrayToDataTable([
            ['Trends', 'KPI Performance Summary'],
            [sladashboardXval_well, this.wellPerformedTargetSLAKPICount]
          ]);

        }
        if (this.wellPerformedTargetSLAKPICount <= 0 && this.underPerformedTargetSLAKPICount > 0) {

          chartData = google.visualization.arrayToDataTable([
            ['Trends', 'KPI Performance Summary'],
            [sladashboardXval_under, this.underPerformedTargetSLAKPICount],
          ]);

        }

        let temp = this;
        const options = {
         
         // legend: { position: 'left' },
          pieHole: 0.4,
          fontSize: 15,
          legend: {
            textStyle: {
              fontSize: 12
            }
          },
          chartArea: { left: 10, top: 50, right: 0, bottom: 10, width: "90%", height: "100%" },
          
          //slices: {
          //  0: { color: '#428893' },
          //  1: { color: '#68b097' },
          //  2: { color: '#83ceb1' },
          //  3: { color: '#aaebac' },
          //  4: { color: '#de8060' },
          //  5: { color: '#f5d17a' },
          //  6: { color: '#efa96c' },
          //  7: { color: '#de8060' },
          //  8: { color: '#a44b2d' }
          //},
//          colors: ['#fcba03','#07db0a','#04d4bb','#2b7ebd','#85979e','#5a666b','#093c63','#036e61',
//'#026b04']
        };
        setTimeout(() => {
          if (document.getElementById('sla_performance_chart')) {
            const chart = new google.visualization.PieChart(document.getElementById('sla_performance_chart'));
            chart.draw(chartData, options);
            google.visualization.events.addListener(chart, 'select', () => {
              if (chart.getSelection().length > 0) {
                let selRow = chart.getSelection();
                let text = chartData.cache[selRow[0].row][0]
                
               
                temp.pointClicksla(text['Ve']);
              }
            });
          }
          this.loading = false;
        }, 500);



      },
        (error) => {
          //Called when error
          this.loading = false;
          if (!isPageLoad) { this.spinner.hide(); }
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        if (!isPageLoad) { this.spinner.hide(); }
      });
  }
  //FOR SLA
  onchangeYear_sla(e) {
    if (!this.isStart) {
      //  this.yearUno = e.itemData.value;
      this.year_sla = (e && e.length > 0) ? e[0].value : 0;
      this.loadSLAKPIDashBoard(this.year_sla, this.quater_sla, this.division_sla, false);
    }
  }

  onchangeQuarter_sla(e) {
    if (!this.isStart) {
      //  this.quarterUno = e.itemData.value;
      this.quater_sla = (e && e.length > 0) ? e[0].value : 0;
      this.loadSLAKPIDashBoard(this.year_sla, this.quater_sla, this.division_sla, false);
    }
  }
  onchangeDivisionSLAKPI(e) {
    if (!this.isStart) {
      this.division_sla = (e && e.length > 0) ? e[0].value : 0;
      this.loadSLAKPIDashBoard(this.year_slakpi, this.quater_slakpi, this.division_sla, false);
    }
  }

  //FOR SLA KPI
  onchangeYearKPI(e) {
    if (!this.isStart) {
      //this.yearUno = e.itemData.value;
      this.year_slakpi = (e && e.length > 0) ? e[0].value : 0;
      this.loadKPIDashBoard(this.year_slakpi, this.quater_slakpi, this.division_slakpi, 'slakpi', false);
      //this.loadSLAKPIDashBoard(this.year_sla, this.quater_sla, false);
    }
  }
  onchangeQuarterKPI(e) {

    if (!this.isStart) {
      // this.quarterUno = e.itemData.value;
      this.quater_slakpi = (e && e.length > 0) ? e[0].value : 0;
      this.loadKPIDashBoard(this.year_slakpi, this.quater_slakpi, this.division_slakpi, 'slakpi', false);
      //this.loadSLAKPIDashBoard(this.year_sla, this.quater_sla, false);
    }
  }

  onchangeDivisionKPI(e) {
    
    if (!this.isStart) {
      this.division_slakpi = (e && e.length > 0) ? e[0].value : 0;
      this.loadKPIDashBoard(this.year_slakpi, this.quater_slakpi, this.division_slakpi, 'slakpi', false);
    }
  }

  //FOR Report KPI
  onchangeYearReport(e) {
    if (!this.isStart) {
      // this.yearUno =  e.itemData.value;
      this.year_reportkpi = (e && e.length > 0) ? e[0].value : 0;

      this.loadKPIDashBoard(this.year_reportkpi, this.quater_reportkpi, this.division_reportkpi, 'report', false);
    }
  }
  onchangeQuarterReport(e) {
    if (!this.isStart) {
      //this.quarterUno =  e.itemData.value;
      this.quater_reportkpi = (e && e.length > 0) ? e[0].value : 0;
      this.loadKPIDashBoard(this.year_reportkpi, this.quater_reportkpi, this.division_reportkpi, 'report', false);
    }
  }

  onchangeDivisionReport(e) {
    if (!this.isStart) {
      this.division_reportkpi = (e && e.length > 0) ? e[0].value : 0;
      this.loadKPIDashBoard(this.year_reportkpi, this.quater_reportkpi, this.division_reportkpi, 'report', false);
    }
  }

  //for chart

  //public onAnimationComplete_kpi_dashboard(args: IAccAnimationCompleteEventArgs): void {
  //  if (args != undefined) {
  //    let centerTitle: HTMLDivElement = document.getElementById('center_title') as HTMLDivElement;
  //    if (centerTitle != undefined && centerTitle != null) {
  //      centerTitle.style.fontSize = this.getFontSize(args.accumulation.initialClipRect.width);
  //      let rect: ClientRect = centerTitle.getBoundingClientRect();
  //      if (centerTitle != undefined) {
  //        centerTitle.style.top = (args.accumulation.origin.y + args.accumulation.element.offsetTop - (rect.height / 2)) + 'px';
  //        centerTitle.style.left = (args.accumulation.origin.x + args.accumulation.element.offsetLeft - (rect.width / 2)) + 'px';
  //        centerTitle.style.visibility = 'visible';
  //      }
  //      let points: AccPoints[] = args.accumulation.visibleSeries[0].points;
  //      for (let point of points) {
  //        if (point.labelPosition === 'Outside' && point.labelVisible) {
  //          let label: Element = document.getElementById('donut-container_datalabel_Series_0_text_' + point.index);
  //          label.setAttribute('fill', 'black');
  //        }
  //      }
  //    }

  //  }

  //};
  public getFontSize(width: number): string {
    if (width > 300) {
      return '13px';
    } else if (width > 250) {
      return '8px';
    } else {
      return '6px';
    }
  };
  //public onTextRender_kpi_dashboard(args: IAccTextRenderEventArgs): void {
  //  if (args != null && args != undefined) {
  //    //args.series.dataLabel.font.size = this.getFontSize(this.kpipie.initialClipRect.width);
  //    args.text = args.text + '%';
  //  }
  //}

  public ranges_report: Object[] = [
    {
      start: 0, end: 25,
      radius: '108%',
      color: 'red',
      roundedCornerRadius: 0
    },
    {
      start: 25, end: 50,
      radius: '108%',
      color: '#ff8000',
      roundedCornerRadius: 0
    },
    {
      start: 50, end: 75,
      radius: '108%',
      color: '#99ff66',
      roundedCornerRadius: 0
    },
    {
      start: 75, end: 100,
      radius: '108%',
      color: '#195a55',
      roundedCornerRadius: 0
    },
  ];
  public pointers_report: Object[] = [{
    //value: 145, type: 'RangeBar', roundedCornerRadius: 10, animation: { enable: false },
    //pointerWidth: 10, color: '#8BC34A', radius: '60%'
  }];
  // custom code start
  ////public load_report(args: ILoadedEventArgs): void {
  ////  let selectedTheme: string;
  ////  selectedTheme = 'Material';
  ////  args.gauge.theme = <GaugeTheme>(selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1));
  ////}


  resetKPICount() {
    //for KPI
    //this.wellperformKPIRange =0;
    this.wellPerformedTargetKPICount = 0;
    this.underPerformedTargetKPICount = 0;
    this.naTargetKPICount = 0;
    this.totalKPIAverage = 0;
    this.totalKPIReported = 0;



    //For Report
    this.noOfSLAKPICount = 0;
    this.noOfReleasedKPICount = 0;
    this.noOfKPICompletedDataEntryStageCount = 0;
    this.noOfKPIReportedAsNACount = 0;
    this.noOfKPICompletedByStage1Count = 0;
    this.noOfKPICompletedByStage2Count = 0;
    this.noOfKPICompletedByStage3Count = 0;
    this.wellPerformedSLAKPICount = 0;
    this.underPerformedSLAKPICount = 0;
    this.reportUnderperformingCount = 0;
    this.reportPrecentageCount = 0;

  }
  resetSLACount() {


    //For SLAKPI
    this.wellperformSLAKPIRange = 0;
    this.wellPerformedTargetSLAKPICount = 0;
    this.underPerformedTargetSLAKPICount = 0;
    this.naTargetSLAKPICount = 0;
    this.totalSLAKPIAverage = 0;
    this.totalSLAKPIReported = 0;


  }

  slaissuelistredirect() {
    this.router.navigate(['/slaissuelist'], { queryParams: { yearsla: this.year_reportkpi, quatersla: this.quater_reportkpi, divisionsla: this.division_reportkpi } });

  }
  kpidatabaseredirect() {
    this.router.navigate(['/slakpidatabase'], { queryParams: { yearsla: this.year_reportkpi, quatersla: this.quater_reportkpi, divisionsla: this.division_reportkpi } });

  }
  slaperformanceredirect() {
    this.router.navigate(['/slaperformance'], { queryParams: { yearsla: this.year_sla, quatersla: this.quater_sla, divisionsla: this.division_sla } });

  }
  kpiperformanceredirect() {
    this.router.navigate(['/slakpiperformance'], { queryParams: { yearsla: this.year_slakpi, quatersla: this.quater_slakpi, divisionsla: this.division_slakpi } });

  }
  //pointRender(args: IAccPointRenderEventArgs): void {

  //  let tt: any = args.point["x"];
  //  if (tt.indexOf("Well-Performing") == 0) {

  //    args.fill = "#70ad47";
  //  } else {

  //    args.fill = "#ff5252";
  //  }
  //}
  public textRender(args): void {

    // args.font.color = this.colorCollection[this.count];
    if (args.point["x"].indexOf("Well-Performing") == 0) {
      args.font.color = "#000"

    } else {
      args.font.color = "#000"

    }
  };

  public RoundNum(num, length): number {
    
    var number = Math.round(num * Math.pow(10, length)) / Math.pow(10, length);
    return number;
  }
  //public pointClickKpi(args: IPointEventArgs): void {
  //  
  //  if (args.point.x != null && args.point.x != "") {
  //    let objdivision_slakpi: any = 0;
  //    const result = this.division_data.filter(s => s.divisionNameEn == args.point.x);
  //    if (result.length > 0) {
  //      objdivision_slakpi = result[0].divisionUno;
  //      this.router.navigate(['/slakpiperformance'], { queryParams: { yearsla: this.year_slakpi, quatersla: this.quater_slakpi, divisionsla: objdivision_slakpi, performance: 2 } });
  //    }


  //  }
  //};


  public pointClicksla(selText) {
    
   

      let objdivision_slakpi = (selText.indexOf("Well-Performing")) ? 2 : 1;
      this.router.navigate(['/slaperformance'], { queryParams: { yearsla: this.year_sla, quatersla: this.quater_sla, performance: objdivision_slakpi } });

    
  };

  sentenceCase(str) {
    if ((str === null) || (str === ''))
      return false;
    else
      str = str.toString();

    return str.replace(/\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() +
          txt.substr(1).toLowerCase();
      });
  }
}

